const listVariantClasses = 'site-paragraph-s text-site-neutrals-700';
const linkVariantClasses = '';
const linkContainerClasses = '';
const breadcrumbActiveClasses = 'font-bold text-site-neutrals-900';
const breadcrumbLinkOpt =
  'group p-1 border-transparent focus:outline-0 focus:bg-site-primary-25 focus:border-site-primary-50 rounded-lg hover:underline';
const breadcrumbsCenterIcon = 'flex justify-center items-center';
const breadcrumbsContainer = 'flex items-center';
const breadcrumbsListClasses = 'mx-auto max-w-screen-xl pb-8 lg:mx-auto lg:px-1 md:pb-12';
const breadcrumbTextOpt = 'p-1';

const breadcrumbsSiteTheme = {
  listVariantClasses,
  linkVariantClasses,
  linkContainerClasses,
  breadcrumbActiveClasses,
  breadcrumbLinkOpt,
  breadcrumbsCenterIcon,
  breadcrumbsContainer,
  breadcrumbsListClasses,
  breadcrumbTextOpt,
};

export default breadcrumbsSiteTheme;
